// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from '@models';

export const environment: Environment = {
  production: false,
  environmentName: 'PRE',
  apiUrl: 'https://mhuxcpsfbe.execute-api.eu-west-1.amazonaws.com/pre',
  configuratorApiUrl: 'https://g7r7xsm3d0.execute-api.eu-west-1.amazonaws.com/pre',
  partnershipApiUrl: 'https://api.areaclienti-test.verti.it',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// by default import 'zone.js/dist/zone-error';  // Included with Angular CLI.
